import { useState, useEffect } from 'react';
import { api, Note } from '@/services/api';

// WebSocket utility for note create/update
function sendNoteSync(payload: any): Promise<Note> {
  return new Promise((resolve, reject) => {
    const ws = new WebSocket('ws://localhost:9099/ws/note-sync');
    ws.onopen = () => {
      ws.send(JSON.stringify({ payload }));
    };
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.note) {
          ws.close();
          resolve(data.note);
        } else {
          reject(new Error('Invalid response from note-sync'));
        }
      } catch (err) {
        reject(err);
      }
    };
    ws.onerror = (err) => {
      reject(err);
    };
  });
}

export const useNotes = (): [Note[], (action: { type: 'set' | 'create' | 'update' | 'delete' | 'replaceDraft', note?: Note, notes?: Note[], draftId?: string }) => Promise<void>] => {
  const [notes, setNotes] = useState<Note[]>([]);

  useEffect(() => {
    api.getNotes().then(setNotes).catch(console.error);
  }, []);

  // Unified async setter for CRUD and draft replacement
  const updateNotes = async (action: { type: 'set' | 'create' | 'update' | 'delete' | 'replaceDraft', note?: Note, notes?: Note[], draftId?: string }) => {
    if (action.type === 'set' && action.notes) {
      setNotes(action.notes);
    } else if (action.type === 'create' && action.note) {
      // For draft, just add to state (no API call)
      setNotes([action.note, ...notes]);
    } else if (action.type === 'replaceDraft' && action.note && action.draftId) {
      // Replace draft note (by temp id) with real note from backend
      setNotes(notes.map(n => (n.note_id === undefined && (n as any).id === action.draftId) ? action.note! : n));
    } else if (action.type === 'update' && action.note) {
      const updated = await api.createOrUpdateNote({
        note_id: action.note.note_id,
        title: action.note.title,
        content: action.note.content,
        sequence: action.note.sequence ?? 1,
        status: action.note.status ?? 'ACTIVE',
      });
      setNotes(notes.map(n => n.note_id === updated.note_id ? updated : n));
    } else if (action.type === 'delete' && action.note) {
      setNotes(notes.filter(n => n.note_id !== action.note!.note_id && (n as any).id !== action.note!.note_id));
    }
  };

  return [notes, updateNotes];
};

export default useNotes; 